<template>
    <div class="max-w-500 mx-auto fixed bottom-0 bg-white w-full rounded-t-xl btn-shadow" data-cy="container_campaign_redeem_button">
        <div v-if="!isButtonDisable">
            <button atm="redeem-button" class="bg-a-blue-2140a6 text-white pt-3 pb-2.5 rounded-sm font-bold text-18 w-full btn"
                    data-cy="btn_campaign_redeem"
                    @click="clickRedeem()">
                <span v-html="buttonLbl" data-cy="text_campaign_redeem_button"></span>
            </button>
        </div>
        <div v-else data-cy="container_campaign_redeem_disabled">
            <button class="bg-a-blue-f2f5ff text-a-blue-c2cdf2 pt-3 pb-2.5 rounded-sm font-bold text-18 w-full btn"
                    data-cy="btn_campaign_redeem_disabled"
                    v-html="buttonLbl"></button>
        </div>
        <div v-if="textBtn" class="text-center text-12 text-a-red-ff4d4d pt-2" data-cy="text_campaign_redeem_error" v-html="textBtn"></div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import { CampaignType } from "@/helper/StaticValue.js";
//mixin
import AuthStatusMixin from "@/mixin/AuthStatusMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from '@/mixin/ModalMixin';

export default {
    name: "RedeemButton",
    mixins: [AuthStatusMixin, LocaleMixin, ModalMixin],
    props: {
        detailController: Object,
    },
    data: function() {
        return {
            type: null,
            point: 0,
            pointType: '',
            quantity: 0,
            campaign: {},

            buttonClass: 'disable',
            buttonLbl: '',
            buttonInitiated: false,
            isAllowRedeem: false,
            isUseDefault: false,
            textBtn: ''
        };
    },
    created: function () {
        this.type = this.detailController.type;
        this.point = this.detailController.point;
        this.pointType = this.detailController.pointType;
        this.quantity = this.detailController.quantity;
        this.campaign = this.detailController.campaign;

        this.buttonLbl = this.lbl.redeem_button.default;
        this.isAllowRedeem = this.campaign.isConditionPass;
        this.isButtonDisable = !this.campaign.isConditionPass;
    },
    mounted: function () {
        this.initialRedeemButton();
        this.buttonClass = this.getRedeemButtonClass();
        this.buttonLbl = this.cleanRedeemButtonLabel();
    },
    methods: {
        //Event
        clickRedeem: function () {
            if (this.isAllowRedeem) {
                if (this.isLogin) {
                    this.$emit('clickRedeem');
                } else {
                    this.modal.alertModal
                        .clearModal()
                        .setTitle(this.lbl.redeem_button.alert_headline)
                        .setMsg(this.lbl.redeem_button.alert_login_msg)
                        .setBtnOk(this.lbl.redeem_button.alert_ok_btn)
                        .setTag('redeem-btn')
                        .show();

                    this.modal.alertModal
                        .onClickOk(() => {
                            this.$router.push('/register');
                        });
                }
            }
        },
        //Function
        initialRedeemButton: function () {
            //Check is campaign supported.
            if (this.type == CampaignType.Bid ||
                this.type == CampaignType.Event ||
                this.type == CampaignType.Media) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = 'notsupport';
                this.textBtn = this.lbl.redeem_button.notSupport;
            }

            //check published.
            if (this.campaign.statusID != 3) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = 'notpublish';
                this.textBtn = this.lbl.redeem_button.notPublish;
            }

            //Check expire date.
            if (this.campaign.currentDate > this.campaign.expireDate) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = 'expired';
                this.textBtn = this.type == CampaignType.Buy ? this.lbl.redeem_button.campaignExpiredBuy : this.lbl.redeem_button.campaignExpired;
            }
            //Check sold out.
            if (this.quantity <= 0) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = "soldout";
                this.textBtn = this.type == CampaignType.Buy ? this.lbl.redeem_button.soldOutBuy : this.lbl.redeem_button.soldOut;
            }
            //Do validate when logged in.
            if (this.isLogin) {
                //Check user enough point.
                if (this.point > this.userPoint) {
                    if (this.pointType && this.pointType != 'use') {
                        //Get point, do nothing.
                    } else {
                        this.isAllowRedeem = false;
                        this.isButtonDisable = true;
                        this.buttonClass = 'notenoughpoint';
                        this.textBtn = this.lbl.redeem_button.notEnoughPoint;
                    }
                }
                //Handle common case for custom text.
                if (!this.campaign.isConditionPass) {
                    this.isAllowRedeem = false;
                    this.isButtonDisable = true;
                    //Use api text message.
                    if (this.isUseDefault) {
                        this.buttonClass = 'condition';
                        this.textBtn = this.campaign.conditionAlert;
                    } else {
                        switch (this.campaign.conditionAlertId) {
                            case 0:
                                //Should not happening (case 0 means this campaign can be redeem).
                                this.textBtn = this.lblnone;
                                break;
                            case 1:
                                //Campaign is soldout.
                                this.buttonClass = "soldout";
                                this.textBtn = this.type == CampaignType.Buy ? this.lbl.redeem_button.soldOutBuy : this.lbl.redeem_button.soldOut;
                                break;
                            case 2:
                                //User already redeem to maximun per person.
                                this.buttonClass = "maxperson";
                                this.textBtn = this.lbl.redeem_button.maxPerPerson;
                                break;
                            case 3:
                                //Campaign is on cooldown.
                                this.buttonClass = "cooldown";
                                this.textBtn = this.lbl.redeem_button.redeemCoolDown;
                                break;
                            case 4:
                                //Never see this.
                                this.textBtn = this.lbl.redeem_button.exceedBuyPointLimitPerday;
                                break;
                            case 1403:
                                //User cannot redeem due to campaign condition and user level.
                                this.buttonClass = "eligible";
                                this.textBtn = this.lbl.redeem_button.conditionIsInvalid; //Not eligible.
                                break;
                            case 1409:
                                //Campaign is already expire.
                                this.buttonClass = "expired";
                                this.textBtn = this.type == CampaignType.Buy ? this.lbl.redeem_button.campaignExpiredBuy : this.lbl.redeem_button.campaignExpired;
                                break;
                            case 1410:
                                //Campaign is not available.
                                this.textBtn = this.type == CampaignType.Buy ? this.lbl.redeem_button.campaignNotAvailableBuy : this.lbl.redeem_button.campaignNotAvailable;
                                break;
                            default:
                                //Other case.
                                this.buttonClass = "condition";
                                this.textBtn = this.campaign.conditionAlert;
                                break;
                        }
                    }
                } else {
                    this.buttonClass = 'allow';

                    if (this.campaign.customCaption) {
                        this.buttonLbl = this.campaign.customCaption;
                    }
                }
            } else {
                this.buttonClass = 'allow';

                if (this.campaign.customCaption) {
                    this.buttonLbl = this.campaign.customCaption;
                }
            }
            this.$nextTick(() => {
                this.buttonInitiated = true;
            });
        },
        //Utilities
        cleanRedeemButtonLabel: function () {
            return Util.newLineToBr(this.buttonLbl);
        },
        getRedeemButtonClass: function () {
            if (!this.isAllowRedeem)
                return this.buttonClass;

            return 'allow';
        },
    }
}
</script>
<style lang="scss" scoped>
.btn {
    height: 50px;
}
</style>
